import React from 'react';
import { Link } from 'react-router-dom';

const Hero: React.FC = () => {
  return (
    <section className="py-16 md:py-24 lg:py-32 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center justify-center gap-10">
          <div className="md:w-1/2 text-center md:text-left mb-10 md:mb-0">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-black mb-6 italic uppercase tracking-tight leading-tight">
            We Bring You 10 Qualified Buyers in 30 Days <br />
              <span className="text-primary">Or You Don't Pay.</span>
            </h1>
            
            <p className="text-lg mb-10 max-w-xl">
            AI-powered lead generation + automated follow-up = more sales.
            </p>
            
            <div className="mb-8">
              <Link 
                to="/contact" 
                className="bg-primary text-white px-8 py-3 rounded-md font-bold text-lg inline-block transform hover:scale-105 transition-all duration-200 uppercase animate-wiggle animate-pulse-glow"
                style={{ 
                  textShadow: '0 2px 4px rgba(0,0,0,0.3)',
                  animation: 'wiggle 3s ease-in-out infinite, pulse-glow 2s ease-in-out infinite'
                }}
              >
                APPLY TO WORK WITH THE AI AGENCY IN THE US
              </Link>
            </div>
          </div>
          
          <div className="md:w-2/5">
            <div className="relative transform transition-all duration-300 hover:scale-[1.02]">
              <img 
                src="/images/infographic.png" 
                alt="AI Technology Infographic" 
                className="w-full h-auto"
              />
            </div>
          </div>
        </div>
        
        <div className="mt-16 text-center">
          <div className="text-center mb-6">
            <p className="text-gray-600 font-medium">Proudly working with</p> 
          </div>
          
          <div className="w-full overflow-hidden relative">
            <div className="brands-scroll-wrapper">
              <div 
                className="brands-scroll"
                style={{
                  display: 'flex',
                  width: '200%',
                  animation: 'marquee 40s linear infinite',
                  whiteSpace: 'nowrap'
                }}
              >
                <div style={{ width: '50%', height: '60px' }}>
                  <img 
                    src="/images/brands.png" 
                    alt="Brand Logos" 
                    className="h-12 md:h-16 object-contain" 
                    style={{ maxWidth: 'none', opacity: '0.8' }}
                  />
                </div>
                <div style={{ width: '50%', height: '60px' }}>
                  <img 
                    src="/images/brands.png" 
                    alt="Brand Logos" 
                    className="h-12 md:h-16 object-contain" 
                    style={{ maxWidth: 'none', opacity: '0.8' }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <style>
        {`
          @keyframes marquee {
            0% {
              transform: translateX(0);
            }
            100% {
              transform: translateX(-50%);
            }
          }
          
          .brands-scroll-wrapper {
            overflow: hidden;
            margin: 0 auto;
            max-width: 100%;
          }
          
          .brands-scroll img {
            display: inline-block;
          }
          
          @media (hover: hover) {
            .brands-scroll:hover {
              animation-play-state: paused;
            }
          }
        `}
      </style>
    </section>
  );
};

export default Hero; 